module.exports = __webpack_public_path__ + "img/Coustard-Regular.ttf.6f2d63f2.svg";